// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1fdSI","header":"MessagesList_header__2Hof5","chat":"MessagesList_chat__nGOWS"};